"use client";
import React from "react";
import Image, { StaticImageData } from "next/image";

interface MetricCard {
  id: number;
  title: string;
  value: string;
  icon: StaticImageData;
}

interface ProvenBuiltProps {
  metrics: MetricCard[];
}

const ProvenBuilt: React.FC<ProvenBuiltProps> = ({ metrics }) => {
  return (
    <>
      <div className="bg-[#F6F8FE]">
        <div className="container mx-auto px-4 py-8 xl:py-16">
          <div className="mb-8 text-center">
            <h2 className="mb-4 text-center text-[24px] font-semibold text-[#202020] lg:text-[32px]">
              Proven Enterprise Search Results
            </h2>
            <p className="text-[14px] font-normal text-[#202020] xl:text-[16px]">
              See the measurable impact Kroolo enterprise search tool delivers
              to enterprise teams
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {metrics.map((item) => (
              <div
                key={item.id}
                className="rounded-2xl bg-white p-4 text-center"
              >
                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center p-1">
                  <Image
                    src={item.icon}
                    alt={item.title}
                    className="h-full w-full object-contain"
                  />
                </div>
                <h3 className="mb-2 text-[14px] font-medium text-[#202020] xl:text-[16px]">
                  {item.title}
                </h3>
                <p className="text-[16px] font-semibold bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent xl:text-[24px]">
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProvenBuilt;
